import { defineStore } from 'pinia'
import { computed, Ref, ref, watch } from 'vue'
import { API } from '@remote/api/base'
import { store } from '@remote/store'



/**
 * 变量是否准备完毕
 * TODO: Error的情况，需要考虑怎么处理。
 * @param targetRef 需要监听是否就绪的变量
 * @param condition 判断变量就绪的条件
 */
const useRefReady = <T>(targetRef: Ref<T>, condition: (param: T) => boolean) => {
  /**
   * 变量是否已经准备就绪
   */
  const isReady = ref(false)

  /**
   * resolve function 
   * 如果还未就绪，需要把resolve函数存到这里。
   */
  // let resolveFunction:  ((value: void | PromiseLike<void>) => void) | null = null
  const waitings: Array<() => void> = []

  watch(targetRef, (val) => {
    isReady.value = condition(val)
    if (isReady.value && waitings.length) {
      // resolveFunction()
      waitings.forEach(cb => cb())
      waitings.length = 0
    }
  })

  const untilReady = () => {
    return new Promise<void>((resolve) => {
      if (isReady.value) {
        resolve()
      } else {
        // resolveFunction = resolve
        waitings.push(resolve)
      }
    })
  }
  
  return {
    untilReady,
  }
}

/**
 * 判断watch信息是否已经就绪
 */
const useTargetReady = () => {
  /**
   * 以watch接口返回的target字段为就绪标记
   */
  const targetRef = computed(() => {
    return store?.state?.curDeviceRunner?.target
  })
  const { untilReady } = useRefReady(targetRef, (target) => Boolean(target))

  return {
    untilTargetReady: untilReady,
  }
}

/**
 * 一些基础状态的储存
 * vuex store 的 device 模块慢慢往这边转。
 */
export const useBaseStore = defineStore('base', () => {
  /**
   * 全局配置入口
   */
  const baseConfig = ref<API_DEVICE.BaseConfig | null>(null)

  const targetRef = computed(() => {
    // console.log('targetRef', store.state.deviceInfoWatchData.target)
    return store?.state?.space
  })

  /**
   * 可以await这个函数来等待target参数准备好
   * target参数准备好即watch接口的信息已经获取成功
   */
  const { untilTargetReady } = useTargetReady()

  /**
   * 可以await这个函数来等待全局配置准备好
   */
  const { untilReady: untilBaseConfigReady } = useRefReady(baseConfig, (config) => config !== null)

  /**
   * 获取全局配置
   */
  const getBaseConfig = async () => {
    await untilTargetReady()
    if (store.state?.deviceInfoWatchData?.target) {
      try {
        const result = await API.getBaseConfig(store.state?.deviceInfoWatchData?.target)
        baseConfig.value = result
      } catch(error) {
        // 请求出错可能是套件端没有接口，。这里为了处理套件端没有接口的情况（需要隐藏个人影院），将baseConfig重置为空。
        baseConfig.value = {}
      }
    }
  }

  /**
   * target变化时，重新获取配置
   */
  watch(targetRef, getBaseConfig)

  return {
    baseConfig,
    getBaseConfig,
    untilTargetReady,
    untilBaseConfigReady,
  }
})